import authReducer from '../reducers/authReducer';
import configReducer from '../reducers/configReducer';
import dashboardReducer from '../reducers/dashboardReducer';
import formTypeReducer from '../reducers/formTypeReducer';
import messagesReducer from '../reducers/messagesReducer';
import odooFieldReducer from '../reducers/odooFieldReducer';
import odooFormReducer from '../reducers/odooFormReducer';
import userReducer from '../reducers/userReducer';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { persistReducer } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import { thunk } from 'redux-thunk';

// Fix for Vite compatibility: manually create storage
const storage =
  typeof window !== 'undefined'
    ? createWebStorage('local')
    : {
        getItem: () => Promise.resolve(null),
        setItem: () => Promise.resolve(),
        removeItem: () => Promise.resolve(),
      };

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'dashboard', 'odooField'],
};

const rootReducer = combineReducers({
  config: configReducer,
  user: userReducer,
  auth: authReducer,
  dashboard: dashboardReducer,
  formType: formTypeReducer,
  odooForm: odooFormReducer,
  odooField: odooFieldReducer,
  messages: messagesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const configureStore = () => createStore(persistedReducer, applyMiddleware(thunk));

export default configureStore;
